// extracted by mini-css-extract-plugin
module.exports = {"dna":"dna-module--dna--2ABkj"};